export default __webpack_public_path__ + "media/color/huc-2bcc569b.svg";